import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icons/check-success.svg'


const _hoisted_1 = { class: "w-1/2 mx-auto" }
const _hoisted_2 = { class: "flex flex-col items-center gap-4 mb-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl leading-7 font-semibold tracking-wider text-blue-900" }, " Pembayaran Berhasil ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = { class: "text-xs leading-5 text-gray-400" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm leading-6 text-gray-400" }, "Tipe Transaksi"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm leading-6 text-gray-400" }, "Tambah Peserta")
], -1)
const _hoisted_7 = { class: "flex justify-between mb-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm leading-6 text-gray-400" }, "Status", -1)
const _hoisted_9 = { class: "bg-green-500 rounded-full px-3 py-1 text-xs leading-5 text-white tracking-wide font-semibold" }
const _hoisted_10 = { class: "flex justify-between mb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm leading-6 text-gray-400" }, "Tanggal", -1)
const _hoisted_12 = { class: "text-sm leading-6 text-gray-400" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4 border-gray-200" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_invitation_summary = _resolveComponent("invitation-summary")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.invoiceSummaryData.invoice_number), 1)
    ]),
    _createElementVNode("div", null, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.invoiceSummaryData.status), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatDateTime(_ctx.invoiceSummaryData.created_at)), 1)
      ])
    ]),
    _hoisted_13,
    _createVNode(_component_invitation_summary, { data: _ctx.invitationSummaryData }, null, 8, ["data"]),
    _createVNode(_component_router_link, {
      to: `/admin/project/${_ctx.invitationSummaryData.project_id}`,
      class: "w-full px-4 py-2 bg-yellow-400 border-1 border-yellow-400 rounded text-black leading-6 text-sm font-semibold flex items-center justify-center gap-3 mb-3"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Selesai ")
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}